export const API_URL = "https://darshanrathazurebackend.azurewebsites.net/api";

//export const API_URL = "http://localhost:5000/api";
